import React from 'react';
import { DropdownMenu, Label } from '@spark';
import { formatSelectedBaseModelLabel } from '@/features/trainings/api/baseModelsApi';
import { useBaseModels } from '@/features/trainings/hooks/useBaseModels';
import './AdvancedDropdownPanel.css';

/**
 * "Base model" dropdown for Train -> Advanced (every task type).
 * Options come from `GET /base-models?task_type=...`, preceded by "Automatic"
 * (`null`, the default). The choice is a parameter of the next training
 * session only: `onChange` receives the model id, or `null` for automatic.
 * Typing in the field fuzzy-searches the model labels and ids.
 */
const BaseModelSelector = ({ taskType, value = null, onChange }) => {
    const { models } = useBaseModels(taskType);
    const options = [{ id: null, label: formatSelectedBaseModelLabel(null) }, ...models];
    const selectedLabel = options.find((option) => option.id === value)?.label || formatSelectedBaseModelLabel(null);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, width: 286 }}>
            <Label label="Base model" showAsterisk={false} showIcon={false} />
            <DropdownMenu
                showLabel={false}
                placeholder="Search base models"
                text={selectedLabel}
                value={selectedLabel}
                searchable
                searchMode="trigger"
                fuzzySearch
                searchEmptyText="No matching base model"
                items={options.map((option) => ({
                    label: option.label,
                    searchText: option.id ? `${option.label} ${option.id}` : option.label,
                    state: option.id === value ? 'selected' : 'default',
                    onClick: () => {
                        if (option.id !== value) onChange?.(option.id);
                    },
                }))}
                size="medium"
                fill
                panelClassName="train-advanced-dropdown-panel"
            />
        </div>
    );
};

export default BaseModelSelector;
